type List<T> = ArrayLike<T>

export function difference<T>(
  array: List<T> | null | undefined,
  ...values: Array<List<T> | undefined | null>
): T[] {
  // If the first array is undefined or null, return an empty array
  if (!array) {
    return []
  }

  // Flatten all the subsequent arrays into a single Set for fast lookup
  const valuesSet = values.flat()

  // Filter the first array, keeping only the elements not in any of the subsequent arrays
  const finalArray: T[] = []

  for (let i = 0; i < array.length; i++) {
    // @ts-expect-error
    if (!valuesSet.includes(array[i])) {
      // @ts-expect-error
      finalArray.push(array[i])
    }
  }

  return finalArray
}
